import {
    ILinks,
    IAxxessIntelligenceDataProps,
    IAxxessIntelligenceUICardGroup,
    IAxxessIntelligenceUICardItem
} from "../../interfaces/i-axxess-intelligence";

import { AxxessIntelligencePageEnum } from "../../enums/axxess-intelligence-thumbs-enum";

export const buildUIModel = (response: any) => {
    const grouped: Record<string, Record<number, IAxxessIntelligenceDataProps[]>> = {};

    // First pass: transform and group
    response.Cards.forEach((card: any) => {
        const { CardType, Data, Links } = card;
        const cardType = CardType;
        let displayName = card.Data.Title;

        if (card.CardType === AxxessIntelligencePageEnum.report || card.CardType === AxxessIntelligencePageEnum.page) {
            displayName = card.CardType;
        } else {
            displayName =
                card.CardType === AxxessIntelligencePageEnum.physician ? card.Data.Title : toTitleCase(card.Data.Title);
        }

        const updatedLinks = Links.map((link: any) => {
            return {
                ...link,
                DisplayName: displayName,
                Type: cardType
            };
        });

        if (card.Links.length !== 0) {
            const updateCard: IAxxessIntelligenceDataProps = {
                ...card,
                Links: updatedLinks
            };

            if (!grouped[cardType]) {
                grouped[cardType] = {};
            }

            if (!grouped[cardType][Data.Id]) {
                grouped[cardType][Data.Id] = [];
            }

            grouped[cardType][Data.Id].push(updateCard);
        }
    });

    // Second pass: shape UI
    const uiResult: IAxxessIntelligenceUICardGroup[] = Object.entries(grouped).map(([cardType, dataGroups]) => {
        let linkCount = 0;
        const uiGroup: IAxxessIntelligenceUICardGroup = {
            CardType: cardType,
            Items: Object.values(dataGroups).map((cards) => {
                const title =
                    cardType === AxxessIntelligencePageEnum.physician
                        ? cards[0].Data.Title
                        : toTitleCase(cards[0].Data.Title);
                const highlights = cards[0].Data.Highlights;

                // Merge and de-duplicate links by Id
                const linkMap = new Map<string, ILinks>();
                cards.forEach((c) => {
                    c.Links.forEach((link) => {
                        if (!linkMap.has(link.Id)) {
                            linkMap.set(link.Id, {
                                ...link,
                                Title: toTitleCase(link.Title) ?? ""
                            });
                        }
                    });
                });

                const links = Array.from(linkMap.values());
                linkCount += links.length;

                return {
                    Title: title,
                    Hightlights: highlights,
                    Links: links
                };
            }),
            ItemCount: Object.values(dataGroups).length,
            LinkCount: linkCount
        };

        uiGroup.AverageLinkCountPerGroup = getMedian(uiGroup.Items.map((u) => u.Links.length));

        return uiGroup;
    });
    return uiResult;
};

const toTitleCase = (value?: string) => {
    if (!value) {
        return value;
    }
    const minorWords = new Set([
        "a",
        "an",
        "and",
        "as",
        "at",
        "but",
        "by",
        "for",
        "in",
        "nor",
        "of",
        "on",
        "or",
        "per",
        "the",
        "to",
        "vs",
        "vi"
    ]);
    const words = value.trim().toLowerCase().split(/\s+/);

    return words
        .map((word, index) => {
            const isFirst = index === 0;
            const isLast = index === words.length - 1;

            if (!isFirst && !isLast && minorWords.has(word)) {
                return word;
            }

            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
};

const getMedian = (items: number[]) => {
    if (!items.length) {
        return 0;
    }

    const sorted = [...items].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);

    return sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid];
};

export const shouldNotGroupResult = (item: IAxxessIntelligenceUICardItem) => {
    return item.Links.length < 2;
};

export const trimWords = (text: string, maxL: number) => {
    if (!text) { return ""; }
    if (text.length <= maxL) { return text; }

    let trimmed = text.substring(0, maxL);
    const lastSpace = trimmed.lastIndexOf(" ");
    trimmed = trimmed.substring(0, lastSpace);

    return trimmed + "...";
};

export const checkLinkOverflowHelpCenter = (text: string) => {
    if (!text) {
        return "";
    }

    if (text.length > 75) {
        return text.slice(0, 75).concat("...");
    }
    return text;
};

export const getSpaceBetweenItemName = (text: string) => {
    return text.replace(/([a-z])([A-Z])/g, "$1 $2");
};
